
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { universities } from '../../../mocks/universities';

export default function OpenOpportunities() {
  const navigate = useNavigate();
  
  // الأقسام الرئيسية المطلوبة
  const mainCategories = [
    { id: 'high-school', name: 'خريجي الثانوية', level: 'bachelor' },
    { id: 'graduate', name: 'الدراسات العليا', level: 'graduate' },
    { id: 'universities', name: 'الجامعات', level: 'all' },
    { id: 'student-life', name: 'حي الطلاب', level: 'student-life' }
  ];

  const [activeTab, setActiveTab] = useState(mainCategories[0].id);
  const [filters, setFilters] = useState({
    level: 'all',
    gender: 'both',
  });

  const getStatusBadge = (status: string) => {
    if (status === 'open') {
      return (
        <span className="inline-flex items-center gap-1 bg-[#132249] text-white px-3 py-1 rounded-full text-xs font-bold font-tajawal">
          <i className="ri-checkbox-circle-fill"></i>
          <span>مفتوح</span>
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold font-tajawal">
        <i className="ri-time-line"></i>
        <span>قريباً</span>
      </span>
    );
  };

  // تصفية الجامعات حسب القسم المحدد والفلاتر
  const getFilteredUniversities = () => {
    let filtered = universities.filter(u => u.status === 'open');
    
    // تصفية حسب التبويب النشط
    if (activeTab === 'high-school') {
      filtered = filtered.filter(u => u.level === 'bachelor');
    }
    // لا حاجة لتعيين filtered لنفسه في الحالات الأخرى

    // تصفية حسب المستوى التعليمي
    if (filters.level !== 'all') {
      filtered = filtered.filter(u => u.level === filters.level);
    }

    // تصفية حسب الجنس
    if (filters.gender !== 'both') {
      filtered = filtered.filter(u => u.gender === filters.gender || u.gender === 'both');
    }
    
    return filtered.slice(0, 6);
  };

  const filteredUniversities = getFilteredUniversities();

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-cairo">
            الفرص المتاحة الآن
          </h2>
          <p className="text-xl text-gray-600 font-tajawal">
            استكشف الجامعات والفرص التعليمية المتاحة حالياً
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {mainCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveTab(category.id)}
              className={`px-6 py-3 rounded-full font-tajawal font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === category.id
                  ? 'bg-[#132249] text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Filter Section */}
        <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100 mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 font-cairo text-center">
            ابحث عن الجامعة المناسبة
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Level Filter */}
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-3 font-cairo">
                المستوى التعليمي
              </label>
              <select
                value={filters.level}
                onChange={(e) => setFilters({ ...filters, level: e.target.value })}
                className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-[#132249] focus:outline-none font-tajawal cursor-pointer"
              >
                <option value="all">جميع المستويات</option>
                <option value="bachelor">بكالوريوس</option>
                <option value="master">ماجستير</option>
                <option value="phd">دكتوراه</option>
                <option value="diploma">دبلوم</option>
              </select>
            </div>

            {/* Gender Filter */}
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-3 font-cairo">
                الجنس
              </label>
              <div className="flex gap-3">
                <button
                  onClick={() => setFilters({ ...filters, gender: 'both' })}
                  className={`flex-1 px-6 py-3 rounded-xl font-tajawal font-medium transition-all cursor-pointer whitespace-nowrap ${
                    filters.gender === 'both'
                      ? 'bg-[#132249] text-white'
                      : 'bg-white border-2 border-gray-200 text-gray-700 hover:border-[#132249]/30'
                  }`}
                >
                  الكل
                </button>
                <button
                  onClick={() => setFilters({ ...filters, gender: 'female' })}
                  className={`flex-1 px-6 py-3 rounded-xl font-tajawal font-medium transition-all cursor-pointer whitespace-nowrap ${
                    filters.gender === 'female'
                      ? 'bg-[#132249] text-white'
                      : 'bg-white border-2 border-gray-200 text-gray-700 hover:border-[#132249]/30'
                  }`}
                >
                  إناث
                </button>
                <button
                  onClick={() => setFilters({ ...filters, gender: 'male' })}
                  className={`flex-1 px-6 py-3 rounded-xl font-tajawal font-medium transition-all cursor-pointer whitespace-nowrap ${
                    filters.gender === 'male'
                      ? 'bg-[#132249] text-white'
                      : 'bg-white border-2 border-gray-200 text-gray-700 hover:border-[#132249]/30'
                  }`}
                >
                  ذكور
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Universities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredUniversities.map((university) => (
            <div
              key={university.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:scale-105 cursor-pointer group"
              onClick={() => navigate(`/opportunity/${university.id}`)}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={university.image}
                  alt={university.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4">{getStatusBadge(university.status)}</div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 font-cairo group-hover:text-[#132249] transition-colors">
                  {university.name}
                </h3>
                <p className="text-gray-600 font-tajawal text-sm mb-4 line-clamp-2">
                  {university.description}
                </p>

                <div className="flex items-center gap-2 text-gray-500 text-sm mb-3 font-tajawal">
                  <i className="ri-map-pin-line"></i>
                  <span>{university.location}</span>
                </div>

                <div className="flex items-center gap-2 text-gray-500 text-sm mb-4 font-tajawal">
                  <i className="ri-calendar-line"></i>
                  <span>التسجيل حتى: {university.deadline}</span>
                </div>

                {/* Available Departments */}
                {university.departments && university.departments.length > 0 && (
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                      {university.departments.slice(0, 3).map((dept, index) => (
                        <span
                          key={index}
                          className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-tajawal"
                        >
                          {dept}
                        </span>
                      ))}
                      {university.departments.length > 3 && (
                        <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-tajawal">
                          +{university.departments.length - 3} المزيد
                        </span>
                      )}
                    </div>
                  </div>
                )}

                <div className="flex gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/opportunity/${university.id}`);
                    }}
                    className="flex-1 bg-gray-100 text-gray-700 px-4 py-2.5 rounded-xl font-tajawal font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap text-sm"
                  >
                    عرض التفاصيل
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(university.registrationLink, '_blank');
                    }}
                    className="flex-1 bg-gray-900 text-white px-4 py-2.5 rounded-xl font-tajawal font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap text-sm"
                  >
                    سجل الآن
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredUniversities.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 font-tajawal text-lg">
              لا توجد فرص متاحة حالياً في هذا القسم
            </p>
          </div>
        )}

        <div className="text-center">
          <button
            onClick={() => navigate('/opportunities')}
            className="bg-[#132249] text-white px-8 py-4 rounded-full font-tajawal font-bold text-lg hover:bg-[#0d1630] transition-all inline-flex items-center gap-3 cursor-pointer whitespace-nowrap"
          >
            <span>عرض جميع الجامعات</span>
            <i className="ri-arrow-left-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
